import { Header, SubSection, Typography, urlReplace, useBreakpoints, useLoading } from "best-common-react";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getActivePurchaseOpportunities } from "../../api/RequesTixApi";
import MyPurchaseOppTable from "../../components/purchaseOpportunity/MyPurchaseOppTable";
import PurchaseOpportunityCard from "../../components/purchaseOpportunity/PurchaseOpportunityCard";
import RouteConstants from "../../constants/RouteConstants";
import { PurchaseOpportunityDTO } from "../../types/PurchaseOpportunity";
import { useNavigate } from "react-router";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const PurchaseOpportunityList: React.FC = () => {
  const { isMobile } = useBreakpoints();
  const navigate = useNavigate();
  const { loading, setLoading } = useLoading();
  const [opportunities, setOpportunities] = useState<PurchaseOpportunityDTO[]>([]);

  const goToForm = (id: string | number) => {
    navigate(urlReplace(RouteConstants.PURCHASE_OPPORTUNITY.REQUEST, { id }));
  };

  const fetchOpps = async () => {
    try {
      setLoading(true);
      const res: PurchaseOpportunityDTO[] = await getActivePurchaseOpportunities();
      setOpportunities(res);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void fetchOpps();
  }, []);

  return (
    <div>
      <Header title="Purchase Opportunities" />
      <div className="bcr-p-2">
        <SubSection header="Opportunities">
          <Container>
            {opportunities?.length > 0 ? (
              <>
                {opportunities.map((opp: PurchaseOpportunityDTO) => (
                  <PurchaseOpportunityCard
                    key={opp.purchaseOpportunityId}
                    opp={opp}
                    onClick={goToForm}
                    className={clsx({ "bcr-me-2": !isMobile, "bcr-mt-2": isMobile })}
                  />
                ))}
              </>
            ) : !loading ? (
              <Typography elementStyles={{ style: "italic" }}>There are no current purchase opportunities</Typography>
            ) : null}
          </Container>
        </SubSection>
        <SubSection header="My Entries">
          <MyPurchaseOppTable />
        </SubSection>
      </div>
    </div>
  );
};

export default PurchaseOpportunityList;
